export const tags = [
    'ImagerPixelSpacing',
    'ImageOrientationPatient',
    'ImagePositionPatient',
    'SpacingBetweenSlices',
    'SliceThickness',
    'SliceLocation',
];
